import { createApp } from 'vue'
import './index.css'
import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config'
import i18nInstance, { setupI18n } from './i18n'
import { init as initializeApp } from './init'
import authDialog from '@/utils/authDialog'
import { initGlobalVersionInfo } from '@/utils/version'
import dialog from './utils/dialog'
import componentPopup from '@/utils/componentPopup'
import { setCaptchaApp } from '@/utils/loadCaptcha'

// 初始化应用
Promise.all([initializeApp(), setupI18n()])
  .then(() => {
    const app = createApp(App)
    app.use(router)
    app.use(i18nInstance)
    app.use(PrimeVue, {
      unstyled: true,
      locale: {
        // 日历头部用的是这个
        dayNamesMin: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
      }
    })

    // 初始化 authDialog 并绑定应用上下文
    authDialog.setApp(app)
    // 公用dialog 初始化上下文
    dialog.setApp(app)
    // 通用组件弹窗初始化上下文
    componentPopup.setApp(app)
    // 自研验证码初始化上下文
    setCaptchaApp(app)
    // 初始化全局版本信息
    initGlobalVersionInfo()

    app.mount('#app')
  })
  .catch((e) => {
    console.error('❌ 系统初始化报错:', e)
    // 在开发环境显示错误，生产环境可以静默处理
    if (import.meta.env.DEV) {
      alert('系统初始化报错，请检查控制台')
    }
  })
